import type { OrderLine } from '../../gql';

import {
    randNumber,
    randBoolean,
    randFutureDate,
    randCountryCode,
} from '@ngneat/falso';

import {
    mockOrderAssortment,
    mockOrderCustomerGroup,
    mockOrderDeliveryPeriod,
} from './mockOrderFragments';

/** Will return a mocked OrderLine object, useful for tests etc. */
const mockOrderLine = (overwrite?: Partial<OrderLine>): OrderLine => {
    const baseOrderLine: OrderLine = {
        lineNumber: randNumber({ min: 1, max: 100 }),
        orderLineNumber: randNumber({ min: 1000000, max: 9999999 }),
        assortment: mockOrderAssortment(),
        customerGroup: mockOrderCustomerGroup(),
        deliveryPeriod: mockOrderDeliveryPeriod(),
        transportTermCode: ['SEA', 'AIR', 'RAIL', 'TRUCK'][
            randNumber({ min: 0, max: 3 })
        ],
        deliveryTermCode: ['FCA', 'FOB', 'CIF', 'DAP'][
            randNumber({ min: 0, max: 3 })
        ],
        portOfLoadingIso3Code: randCountryCode()[0],
        portOfLoadingName: randBoolean() ? 'Port Name' : undefined,
        quantity: randNumber({ min: 100, max: 10000 }),
        quantityBox: randBoolean()
            ? randNumber({ min: 10, max: 1000 })
            : undefined,
        cargoClosingDate: randFutureDate(),
        arrivalDate: randFutureDate(),
        isDeleted: false,
        isKeyCustomer: randBoolean(),
        isOwnClearance: randBoolean(),
    };

    return { ...baseOrderLine, ...overwrite };
};

export { mockOrderLine };
